import type { FaireProductEntity } from "../../entity_types/product";

export const p_ks8vzdcg3e: FaireProductEntity = {
  token: "p_ks8vzdcg3e",
  type: "product",
  name: "Hawaii Amakihi",
  brandName: "Lucky Horse Press",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/856d83fd46940324de0759d64e512233b9dadb798c0559908ec9db6de2895c67.png",
  priceDollars: 4.1,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/31375e7d9500ae5e209f16d2447fcb70dca3df41ea0568dc316893bac0d17aab/1527816305.jpg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
